import { gql } from '@apollo/client';

export const CLINICS_GET = gql`
  query clinics {
    clinics {
      id
      name
      displayName
      featureFlags
    }
  }
`;
